import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Animated } from "react-animated-css";
import UserManagmentCard from '../../components/audience/usermanagementcard';


import './Audience.css';

class Audience extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:false
		}
	}
	
	render() {
		const { loading} = this.state;

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
						<Col md={24} lg={24} xl={24} xxl={24}>
								<Row>
									 <Col span={24}>
									 	<UserManagmentCard loading={loading}/>
									</Col>
									{/* <Col span={24}>
									 	<SubscriberCountByExpiryCard loading={loading}/>
									</Col> */}
								</Row>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile,
	selectedOrganization: state.user.selectedOrganization,
	inspectionTime: state.analytics.inspectionTime
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Audience);
